<template>
    <div>
        <v-tabs v-model="active">
            <v-tabs-bar class="blue" dark>
                <v-tabs-item key="profile" href="#profile" ripple>
                    Profile
                </v-tabs-item>
                <v-tabs-item key="subordinates" href="#subordinates" ripple>
                    Subordinates
                </v-tabs-item>
                <v-tabs-slider color="white"></v-tabs-slider>
            </v-tabs-bar>
            <v-tabs-items>
                <v-tabs-content key="profile" id="profile">
                    <v-card flat>
                        <v-card-text>
                            <p>Name: {{ userInfo.employee_name }}</p>
                            <p>Designation: {{ userInfo.designation != null ? userInfo.designation.designation_title : 'N/A' }}</p>
                            <p>Email: {{ userInfo.employee_email }}</p>
                            <p>Supervisor: {{ supervisorInfo.employee_name }}</p>
                        </v-card-text>
                    </v-card>
                </v-tabs-content>
                <v-tabs-content key="subordinates" id="subordinates">
                    <v-card flat>
                        <v-card-text>
                            <template>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-card style="width: 100%;">
                                            <v-data-table
                                                    v-model="selected"
                                                    :headers="headers"
                                                    :items="items"
                                                    :search="search"
                                                    :pagination.sync="pagination"
                                                    select-all
                                                    item-key="name"
                                                    :loading="loading"
                                                    class="elevation-1"
                                            >
                                                <template slot="headers" slot-scope="props">
                                                    <tr>
                                                        <th
                                                                v-for="header in props.headers"
                                                                :key="header.text"
                                                                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                                                @click="changeSort(header.value)"
                                                        >
                                                            <v-icon small>arrow_upward</v-icon>
                                                            {{ header.text }}
                                                        </th>
                                                    </tr>
                                                </template>
                                                <template slot="items" slot-scope="props">
                                                    <td style="text-align: center;">{{ props.item.employee_name }}</td>
                                                    <td style="text-align: center;">{{ props.item.employee_email }}</td>
                                                    <td style="text-align: center;">{{ props.item.designation != null ? props.item.designation.designation_title : 'N/A' }}</td>
                                                    <td style="text-align: center;">{{ props.item.branch != null ? props.item.branch[0].name : 'N/A' }}</td>
                                                </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-tabs-content>
            </v-tabs-items>
        </v-tabs>
    </div>
</template>

<script>
    const commonService = require('../../services/common.service');
    export default {
        data() {
            return {
                active: null,
                loading: true,
                pagination: {
                    sortBy: 'id',
                    descending: true,
                },
                selected: [],
                search: '',
                headers: [
                    {text: 'Employee name', align: 'left', value: 'employee_name'},
                    {text: 'Email', value: 'employee_email'},
                    {text: 'Designation', value: 'id'},
                    {text: 'Branch', value: 'branch'},
                ],
                items: [],
                userInfo: '',
                supervisorInfo: {
                    employee_name:'',
                }
            }
        },
        
        created () {

            commonService.getAllData('settings/profile-info').then(res => {
                this.userInfo = res.user;
                if(res.supervisor){
                    this.supervisorInfo = res.supervisor
                }
                this.items = res.supervisorList
                this.loading = false;
            });
        },

        methods: {

        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/profile/UserProfile.vue